export const PagePath = {
  TEMPLATES: "/templates",
  BUILDER: "/builder",
};

export * from "./elementSettings";
export * from "./templates";
